export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_116.f8c0e23b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};